// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_centered-col__ht9Ln {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }

.styles_hide-scrollbar__4sVKO {
  -ms-overflow-style: none;
  scrollbar-width: none; }
  .styles_hide-scrollbar__4sVKO::-webkit-scrollbar {
    display: none; }

.styles_singleLineText__C1X48 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }

.styles_width-fill-available__wFQEO, .styles_auth__de-VS {
  width: 100%;
  /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available;
  /* Mozilla-based browsers will ignore this. */
  width: fill-available; }

.styles_height-fill-available__1KZYl {
  height: 100%;
  /* WebKit-based browsers will ignore this. */
  height: -webkit-fill-available;
  /* Mozilla-based browsers will ignore this. */
  height: fill-available; }

div.styles_drawer__TUEoT {
  transition: 1s width;
  max-width: 25vw;
  box-shadow: unset; }
  div.styles_drawer__TUEoT > div {
    max-width: 25vw;
    padding-bottom: 18%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    align-items: center;
    background-color: white;
    z-index: 100; }
    div.styles_drawer__TUEoT > div > div:first-child {
      height: 5rem; }
      div.styles_drawer__TUEoT > div > div:first-child h2 {
        line-height: 4rem; }

.styles_auth__de-VS {
  display: flex;
  flex-direction: column;
  margin-bottom: 3rem;
  justify-content: center;
  align-items: center; }
  .styles_auth__de-VS button:last-child {
    margin-bottom: 10%;
    width: 90%;
    border-radius: 0.9rem; }
  .styles_auth__de-VS p {
    margin: 0.5rem 0.25rem;
    text-align: center; }

.styles_logoContainer__TJ7Cg {
  height: 100%;
  display: flex;
  align-items: center; }
  .styles_logoContainer__TJ7Cg .styles_logo__hjvLw {
    height: 90%;
    min-height: 3.6rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/styles/classes.scss","webpack://./src/modules/Core/components/Sidebar/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,wBAAwB;EACxB,qBAAqB,EAAA;EAFvB;IAII,aAAa,EAAA;;AAIjB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB,EAAA;;AAGzB;EACE,WAAW;EACY,4CAAA;EACvB,6BAA6B;EAAE,6CAAA;EAC/B,qBAAqB,EAAA;;AAGvB;EACE,YAAY;EACY,4CAAA;EACxB,8BAA8B;EAAE,6CAAA;EAChC,sBAAsB,EAAA;;AC7BxB;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB,EAAA;EAHnB;IAMI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,YAAY,EAAA;IAfhB;MAiBM,YAAY,EAAA;MAjBlB;QAmBQ,iBAAiB,EAAA;;AAMzB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EAEnB,uBAAuB;EACvB,mBAAmB,EAAA;EANrB;IAQI,kBAAkB;IAClB,UAAU;IACV,qBAAqB,EAAA;EAVzB;IAaI,sBAAsB;IACtB,kBAAkB,EAAA;;AAItB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB,EAAA;EAHrB;IAKI,WAAW;IACX,kBAAkB,EAAA","sourcesContent":[".centered-col {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.hide-scrollbar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.singleLineText {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.width-fill-available {\n  width: 100%;\n  width: -moz-available; /* WebKit-based browsers will ignore this. */\n  width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */\n  width: fill-available;\n}\n\n.height-fill-available {\n  height: 100%;\n  height: -moz-available; /* WebKit-based browsers will ignore this. */\n  height: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */\n  height: fill-available;\n}\n","@import \"src/modules/Core/styles/mixins.scss\";\n@import \"src/modules/Core/styles/classes.scss\";\n\ndiv.drawer {\n  transition: 1s width;\n  max-width: 25vw;\n  box-shadow: unset;\n\n  & > div {\n    max-width: 25vw;\n    padding-bottom: 18%;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n    align-items: center;\n    background-color: white;\n    z-index: 100;\n    & > div:first-child {\n      height: 5rem;\n      h2 {\n        line-height: 4rem;\n      }\n    }\n  }\n}\n\n.auth {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 3rem;\n  @extend .width-fill-available;\n  justify-content: center;\n  align-items: center;\n  button:last-child {\n    margin-bottom: 10%;\n    width: 90%;\n    border-radius: 0.9rem;\n  }\n  & p {\n    margin: 0.5rem 0.25rem;\n    text-align: center;\n  }\n}\n\n.logoContainer{\n  height: 100%;\n  display: flex;\n  align-items: center;\n  .logo {\n    height: 90%;\n    min-height: 3.6rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"centered-col": `styles_centered-col__ht9Ln`,
	"hide-scrollbar": `styles_hide-scrollbar__4sVKO`,
	"singleLineText": `styles_singleLineText__C1X48`,
	"width-fill-available": `styles_width-fill-available__wFQEO`,
	"auth": `styles_auth__de-VS`,
	"height-fill-available": `styles_height-fill-available__1KZYl`,
	"drawer": `styles_drawer__TUEoT`,
	"logoContainer": `styles_logoContainer__TJ7Cg`,
	"logo": `styles_logo__hjvLw`
};
export default ___CSS_LOADER_EXPORT___;
